import { themeVars } from '../theme/vars';
import { space } from '../tokens';
import { style } from '../layer.css';

export const checkbox = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  minWidth: 20,
  height: 20,
  padding: 0,
  borderRadius: space.s4,
  border: `1px solid ${themeVars.selectors.border.idle}`,
  backgroundColor: 'transparent',
  // backgroundColor: themeVars.selectors.background.idle,
  cursor: 'pointer',
  transitionProperty: 'background-color, border, color, opacity',
  transitionDuration: '0.15s',

  ':disabled': {
    cursor: 'default',
    backgroundColor: themeVars.selectors.disabled.background,
    color: themeVars.selectors.disabled.foreground,
    borderColor: themeVars.selectors.disabled.border,
  },

  selectors: {
    ['&:hover:not(:disabled, &[data-state=checked], &[data-state=indeterminate])']:
      {
        backgroundColor: themeVars.selectors.background.hover,
      },

    ['&[data-state=checked], &[data-state=indeterminate]']: {
      backgroundColor: themeVars.selectors.background.filled,
      color: themeVars.selectors.foreground.filled,
      borderColor: 'transparent',
    },
  },
});

export const checkboxIndicator = style({
  display: 'flex',
});
